module.exports = __webpack_public_path__ + "static/media/7.0131d802.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/slides/7.png
// module id = 256
// module chunks = 0